module.exports = "../dist/img/product-card-23.19d0.jpg";